module.exports = __webpack_public_path__ + "img/compareBI_1.c292bef7.png";